module.exports = __webpack_public_path__ + "static/img/zj03.8999d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zj03.png
// module id = 140
// module chunks = 0